module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"your-apps":"Seus apps","get-to-know":"Conheça","shop":"Shop","hub":"Hub","new":"Novo","antifraud":"Antifraude"},"en-US":{"your-apps":"Your apps","get-to-know":"Get to know","shop":"Shop","hub":"Hub","new":"New","antifraud":"Anti fraud"}}')
  delete Component.options._Ctor
}
